import { render, staticRenderFns } from "./AreaCompany.vue?vue&type=template&id=f3dfb586&scoped=true&"
import script from "./AreaCompany.vue?vue&type=script&lang=js&"
export * from "./AreaCompany.vue?vue&type=script&lang=js&"
import style0 from "./AreaCompany.vue?vue&type=style&index=0&id=f3dfb586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dfb586",
  null
  
)

export default component.exports